import React, { useState, useMemo } from "react";
import "./styles.less";

let CodeMirror = null;
if (typeof window !== "undefined" && typeof window.navigator !== "undefined") {
  const { Controlled } = require("react-codemirror2");
  CodeMirror = Controlled;
  // https://blog.csdn.net/qq_41694291/article/details/106429772
  require("codemirror/lib/codemirror.css");
  require("codemirror/theme/3024-day.css");
  require("codemirror/mode/htmlembedded/htmlembedded");
}
export const GuardCode = ({ color, theme }) => {
  const [tab, setTab] = useState(1);
  //   const tabitems = ["HTML", "CSS", "JS"];
  const tabitems = ["HTML"];
  const codes = useMemo(() => {
    return [
      `
.guard-login-ui-wrap {
  background: ${color || theme.color};
  border-radius: 4px;
  filter: drop-shadow(0px 0px 40px rgba(84, 89, 104, 0.05));
}

.guard-login-ui .guard-ui-input {
  background: #f5f6f7;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #c8c9cc;
}

.guard-login-ui .guard-ui-button {
  background: ${color || theme.color};
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
        `,
      `css`,
      `js`,
    ];
  }, [color, theme]);
  return (
    <div>
      <div className="guard-code-warp">
        {CodeMirror && (
          <CodeMirror
            value={codes[tab - 1]}
            autoScroll={false}
            className="react-codemirror2"
            options={{
              mode: "css",
              // mode: { name: "HTML" },
              // xml
              theme: "3024-day",
              lineNumbers: true,
            }}
          />
        )}
      </div>
    </div>
  );
};
